import { render, staticRenderFns } from "./SynergismMatterDimensionRow.vue?vue&type=template&id=54f5a626&scoped=true&"
import script from "./SynergismMatterDimensionRow.vue?vue&type=script&lang=js&"
export * from "./SynergismMatterDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./SynergismMatterDimensionRow.vue?vue&type=style&index=0&id=54f5a626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5a626",
  null
  
)

export default component.exports